import {bindAllFktToClass} from './binder'

export class AbstractClass {
	constructor() {
		bindAllFktToClass(this)
	}

	public test() {}
}
